/**
 *
 * @param promoData
 * @returns {string}
 */
export const formatPromoData = (promoData) => {
  if (promoData >= 1000) {
    return `${promoData / 1000}GB`;
  }
  return `${promoData}MB`;
};

/**
 * Extracts the sum of promo_data value from the plan object products
 *
 * @param plan
 * @returns {number|null}
 */
export const extractPromoData = (plan) => {
  if (!plan || !plan.items) {
    return null;
  }

  // Find the item with title "Promo"
  const promoItem = plan.items.find(item => item.title === "Promo");

  if (!promoItem || !promoItem.options) {
    return null;
  }

  // Extract promo_data values from each product in the options array
  const promoDataValues = promoItem.options
    .map(option => option?.product?.promo_data)
    .filter(value => value !== null && value !== undefined);

  // If there are no valid promo_data values, return null
  if (promoDataValues.length === 0) {
    return null;
  }

  if (promoDataValues.length === 1) {
    return promoDataValues[0];
  }

  return promoDataValues.reduce((sum, value) => sum + value, 0);
}
